import React, { Fragment } from 'react';
import { createTooltipIcon } from '../utils/createTooltipIcon';

export const Dairy = createTooltipIcon(
  () => (
    <Fragment>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.64711e-06 18.55C4.64711e-06 17.7216 0.671578 17.05 1.5 17.05H33.7885C34.6169 17.05 35.2885 17.7216 35.2885 18.55V63.6991C35.2885 64.5275 34.6169 65.1991 33.7885 65.1991H1.5C0.671578 65.1991 4.64711e-06 64.5275 4.64711e-06 63.6991V18.55ZM3 20.05V62.1991H32.2885V20.05H3Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.55469 1.5C6.55469 0.671573 7.22626 0 8.05469 0H27.2345C28.0629 0 28.7345 0.671573 28.7345 1.5V9.24615C28.7345 10.0746 28.0629 10.7462 27.2345 10.7462H8.05469C7.22626 10.7462 6.55469 10.0746 6.55469 9.24615V1.5ZM9.55469 3V7.74615H25.7345V3H9.55469Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.82862 8.38261C7.10961 7.98382 7.56697 7.74658 8.05481 7.74658H27.2346C27.7225 7.74658 28.1799 7.98385 28.4609 8.38269L35.0147 17.6856C35.3373 18.1435 35.3779 18.743 35.12 19.2402C34.8621 19.7374 34.3486 20.0495 33.7885 20.0495H1.5C0.939861 20.0495 0.426386 19.7374 0.168471 19.2401C-0.0894433 18.7429 -0.0488209 18.1434 0.273812 17.6855L6.82862 8.38261ZM8.83286 10.7466L4.39185 17.0495H30.8969L26.4565 10.7466H8.83286Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.11329 23.1631C7.66557 23.1631 8.11329 23.6108 8.11329 24.1631V42.0862C8.11329 42.6385 7.66557 43.0862 7.11329 43.0862C6.561 43.0862 6.11329 42.6385 6.11329 42.0862V24.1631C6.11329 23.6108 6.561 23.1631 7.11329 23.1631Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.11329 45.3274C7.66557 45.3274 8.11329 45.7751 8.11329 46.3274V51.7995C8.11329 52.3518 7.66557 52.7995 7.11329 52.7995C6.561 52.7995 6.11329 52.3518 6.11329 51.7995V46.3274C6.11329 45.7751 6.561 45.3274 7.11329 45.3274Z"
      />
    </Fragment>
  ),
  '0 0 36 66'
);
